"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProviderType = exports.AuthMethodType = exports.SIGTYPE = exports.VMTYPE = void 0;
/** ---------- Chains ---------- */
var VMTYPE;
(function (VMTYPE) {
    VMTYPE["EVM"] = "EVM";
    VMTYPE["SVM"] = "SVM";
    VMTYPE["CVM"] = "CVM";
})(VMTYPE = exports.VMTYPE || (exports.VMTYPE = {}));
var SIGTYPE;
(function (SIGTYPE) {
    SIGTYPE["BLS"] = "BLS";
    SIGTYPE["ECDSA"] = "ECDSA";
})(SIGTYPE = exports.SIGTYPE || (exports.SIGTYPE = {}));
/**
 * Supported PKP auth method types
 */
var AuthMethodType;
(function (AuthMethodType) {
    AuthMethodType[AuthMethodType["EthWallet"] = 1] = "EthWallet";
    AuthMethodType[AuthMethodType["LitAction"] = 2] = "LitAction";
    AuthMethodType[AuthMethodType["WebAuthn"] = 3] = "WebAuthn";
    AuthMethodType[AuthMethodType["Discord"] = 4] = "Discord";
    AuthMethodType[AuthMethodType["Google"] = 5] = "Google";
    AuthMethodType[AuthMethodType["GoogleJwt"] = 6] = "GoogleJwt";
    AuthMethodType[AuthMethodType["OTP"] = 7] = "OTP";
})(AuthMethodType = exports.AuthMethodType || (exports.AuthMethodType = {}));
/**
 * Supported provider types
 */
var ProviderType;
(function (ProviderType) {
    ProviderType["Discord"] = "discord";
    ProviderType["Google"] = "google";
    ProviderType["EthWallet"] = "ethwallet";
    ProviderType["WebAuthn"] = "webauthn";
    ProviderType["Otp"] = "otp";
})(ProviderType = exports.ProviderType || (exports.ProviderType = {}));
//# sourceMappingURL=enums.js.map